import { isObject } from 'lodash-es';
import * as i0 from '@angular/core';
import { InjectionToken, inject, PLATFORM_ID, signal, computed, Injectable } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { filter, take } from 'rxjs/operators';

const ApplicationId = {
    COMPOSABLE_ADMIN: 1505,
    COMPOSABLE_STOREFRONT: 1506,
    COMPOSABLE_PRODUCT_LOCALES: 1507,
};

const COUNTRIES = [
    { code: 'AD', phoneCode: '+376' },
    { code: 'AE', phoneCode: '+971' },
    { code: 'AF', phoneCode: '+93' },
    { code: 'AG', phoneCode: '+1' },
    { code: 'AI', phoneCode: '+1' },
    { code: 'AL', phoneCode: '+355' },
    { code: 'AM', phoneCode: '+374' },
    { code: 'AN', phoneCode: '+599' },
    { code: 'AO', phoneCode: '+244' },
    { code: 'AR', phoneCode: '+54' },
    { code: 'AT', phoneCode: '+43' },
    { code: 'AU', phoneCode: '+61' },
    { code: 'AW', phoneCode: '+297' },
    { code: 'AZ', phoneCode: '+994' },
    { code: 'BA', phoneCode: '+387' },
    { code: 'BB', phoneCode: '+1' },
    { code: 'BD', phoneCode: '+880' },
    { code: 'BE', phoneCode: '+32' },
    { code: 'BF', phoneCode: '+226' },
    { code: 'BG', phoneCode: '+359' },
    { code: 'BH', phoneCode: '+973' },
    { code: 'BI', phoneCode: '+257' },
    { code: 'BJ', phoneCode: '+229' },
    { code: 'BM', phoneCode: '+1' },
    { code: 'BN', phoneCode: '+673' },
    { code: 'BO', phoneCode: '+591' },
    { code: 'BQ', phoneCode: '+599' },
    { code: 'BR', phoneCode: '+55' },
    { code: 'BS', phoneCode: '+1' },
    { code: 'BT', phoneCode: '+975' },
    { code: 'BV', phoneCode: '+55' },
    { code: 'BW', phoneCode: '+267' },
    { code: 'BY', phoneCode: '+375' },
    { code: 'BZ', phoneCode: '+501' },
    { code: 'CA', phoneCode: '+1' },
    { code: 'CC', phoneCode: '+891' },
    { code: 'CD', phoneCode: '+243' },
    { code: 'CF', phoneCode: '+236' },
    { code: 'CG', phoneCode: '+242' },
    { code: 'CH', phoneCode: '+41' },
    { code: 'CI', phoneCode: '+225' },
    { code: 'CK', phoneCode: '+682' },
    { code: 'CL', phoneCode: '+56' },
    { code: 'CM', phoneCode: '+237' },
    { code: 'CN', phoneCode: '+86' },
    { code: 'CO', phoneCode: '+57' },
    { code: 'CR', phoneCode: '+506' },
    { code: 'CU', phoneCode: '+53' },
    { code: 'CV', phoneCode: '+238' },
    { code: 'CX', phoneCode: '+61' },
    { code: 'CY', phoneCode: '+357' },
    { code: 'CZ', phoneCode: '+420' },
    { code: 'DE', phoneCode: '+49' },
    { code: 'DJ', phoneCode: '+253' },
    { code: 'DK', phoneCode: '+45' },
    { code: 'DM', phoneCode: '+1' },
    { code: 'DO', phoneCode: '+1' },
    { code: 'DZ', phoneCode: '+213' },
    { code: 'EC', phoneCode: '+593' },
    { code: 'EE', phoneCode: '+372' },
    { code: 'EG', phoneCode: '+20' },
    { code: 'ER', phoneCode: '+291' },
    { code: 'ES', phoneCode: '+34' },
    { code: 'ET', phoneCode: '+251' },
    { code: 'FI', phoneCode: '+358' },
    { code: 'FJ', phoneCode: '+679' },
    { code: 'FK', phoneCode: '+500' },
    { code: 'FM', phoneCode: '+691' },
    { code: 'FO', phoneCode: '+298' },
    { code: 'FR', phoneCode: '+33' },
    { code: 'GA', phoneCode: '+241' },
    { code: 'GB', phoneCode: '+44' },
    { code: 'GD', phoneCode: '+1' },
    { code: 'GE', phoneCode: '+995' },
    { code: 'GF', phoneCode: '+594' },
    { code: 'GH', phoneCode: '+233' },
    { code: 'GI', phoneCode: '+350' },
    { code: 'GL', phoneCode: '+299' },
    { code: 'GM', phoneCode: '+220' },
    { code: 'GN', phoneCode: '+224' },
    { code: 'GP', phoneCode: '+590' },
    { code: 'GQ', phoneCode: '+240' },
    { code: 'GR', phoneCode: '+30' },
    { code: 'GS', phoneCode: '+500' },
    { code: 'GT', phoneCode: '+502' },
    { code: 'GW', phoneCode: '+245' },
    { code: 'GY', phoneCode: '+592' },
    { code: 'HK', phoneCode: '+852' },
    { code: 'HM', phoneCode: '+0' },
    { code: 'HN', phoneCode: '+504' },
    { code: 'HR', phoneCode: '+385' },
    { code: 'HT', phoneCode: '+509' },
    { code: 'HU', phoneCode: '+36' },
    { code: 'ID', phoneCode: '+62' },
    { code: 'IE', phoneCode: '+353' },
    { code: 'IL', phoneCode: '+972' },
    { code: 'IN', phoneCode: '+91' },
    { code: 'IO', phoneCode: '+246' },
    { code: 'IQ', phoneCode: '+964' },
    { code: 'IR', phoneCode: '+98' },
    { code: 'IS', phoneCode: '+354' },
    { code: 'IT', phoneCode: '+39' },
    { code: 'JM', phoneCode: '+1' },
    { code: 'JO', phoneCode: '+962' },
    { code: 'JP', phoneCode: '+81' },
    { code: 'KE', phoneCode: '+254' },
    { code: 'KG', phoneCode: '+996' },
    { code: 'KH', phoneCode: '+855' },
    { code: 'KI', phoneCode: '+686' },
    { code: 'KM', phoneCode: '+269' },
    { code: 'KN', phoneCode: '+1' },
    { code: 'KP', phoneCode: '+850' },
    { code: 'KR', phoneCode: '+82' },
    { code: 'KW', phoneCode: '+965' },
    { code: 'KY', phoneCode: '+1' },
    { code: 'KZ', phoneCode: '+7' },
    { code: 'LA', phoneCode: '+856' },
    { code: 'LB', phoneCode: '+961' },
    { code: 'LC', phoneCode: '+1' },
    { code: 'LI', phoneCode: '+423' },
    { code: 'LK', phoneCode: '+94' },
    { code: 'LR', phoneCode: '+231' },
    { code: 'LS', phoneCode: '+266' },
    { code: 'LT', phoneCode: '+370' },
    { code: 'LU', phoneCode: '+352' },
    { code: 'LV', phoneCode: '+371' },
    { code: 'LY', phoneCode: '+218' },
    { code: 'MA', phoneCode: '+212' },
    { code: 'MC', phoneCode: '+377' },
    { code: 'MD', phoneCode: '+373' },
    { code: 'ME', phoneCode: '+382' },
    { code: 'MG', phoneCode: '+261' },
    { code: 'MH', phoneCode: '+692' },
    { code: 'MK', phoneCode: '+389' },
    { code: 'ML', phoneCode: '+223' },
    { code: 'MM', phoneCode: '+95' },
    { code: 'MN', phoneCode: '+976' },
    { code: 'MO', phoneCode: '+853' },
    { code: 'MP', phoneCode: '+1' },
    { code: 'MQ', phoneCode: '+596' },
    { code: 'MR', phoneCode: '+222' },
    { code: 'MS', phoneCode: '+1' },
    { code: 'MT', phoneCode: '+36' },
    { code: 'MU', phoneCode: '+230' },
    { code: 'MV', phoneCode: '+960' },
    { code: 'MW', phoneCode: '+265' },
    { code: 'MX', phoneCode: '+52' },
    { code: 'MY', phoneCode: '+60' },
    { code: 'MZ', phoneCode: '+258' },
    { code: 'NA', phoneCode: '+264' },
    { code: 'NC', phoneCode: '+687' },
    { code: 'NE', phoneCode: '+227' },
    { code: 'NF', phoneCode: '+672' },
    { code: 'NG', phoneCode: '+234' },
    { code: 'NI', phoneCode: '+505' },
    { code: 'NL', phoneCode: '+31' },
    { code: 'NO', phoneCode: '+47' },
    { code: 'NP', phoneCode: '+977' },
    { code: 'NR', phoneCode: '+674' },
    { code: 'NU', phoneCode: '+683' },
    { code: 'NZ', phoneCode: '+64' },
    { code: 'OM', phoneCode: '+968' },
    { code: 'PA', phoneCode: '+507' },
    { code: 'PE', phoneCode: '+51' },
    { code: 'PF', phoneCode: '+689' },
    { code: 'PG', phoneCode: '+675' },
    { code: 'PH', phoneCode: '+63' },
    { code: 'PK', phoneCode: '+92' },
    { code: 'PL', phoneCode: '+48' },
    { code: 'PM', phoneCode: '+508' },
    { code: 'PN', phoneCode: '+64' },
    { code: 'PT', phoneCode: '+351' },
    { code: 'PW', phoneCode: '+680' },
    { code: 'PY', phoneCode: '+595' },
    { code: 'QA', phoneCode: '+974' },
    { code: 'RE', phoneCode: '+262' },
    { code: 'RO', phoneCode: '+40' },
    { code: 'RS', phoneCode: '+381' },
    { code: 'RU', phoneCode: '+7' },
    { code: 'RW', phoneCode: '+250' },
    { code: 'SA', phoneCode: '+966' },
    { code: 'SB', phoneCode: '+677' },
    { code: 'SC', phoneCode: '+248' },
    { code: 'SD', phoneCode: '+294' },
    { code: 'SE', phoneCode: '+46' },
    { code: 'SG', phoneCode: '+65' },
    { code: 'SH', phoneCode: '+290' },
    { code: 'SI', phoneCode: '+386' },
    { code: 'SJ', phoneCode: '+47' },
    { code: 'SK', phoneCode: '+421' },
    { code: 'SL', phoneCode: '+232' },
    { code: 'SM', phoneCode: '+378' },
    { code: 'SN', phoneCode: '+221' },
    { code: 'SO', phoneCode: '+252' },
    { code: 'SR', phoneCode: '+597' },
    { code: 'ST', phoneCode: '+239' },
    { code: 'SV', phoneCode: '+503' },
    { code: 'SY', phoneCode: '+963' },
    { code: 'SZ', phoneCode: '+268' },
    { code: 'TC', phoneCode: '+1' },
    { code: 'TD', phoneCode: '+235' },
    { code: 'TF', phoneCode: '+262' },
    { code: 'TG', phoneCode: '+228' },
    { code: 'TH', phoneCode: '+66' },
    { code: 'TJ', phoneCode: '+992' },
    { code: 'TK', phoneCode: '+690' },
    { code: 'TL', phoneCode: '+670' },
    { code: 'TM', phoneCode: '+993' },
    { code: 'TN', phoneCode: '+216' },
    { code: 'TO', phoneCode: '+676' },
    { code: 'TR', phoneCode: '+90' },
    { code: 'TT', phoneCode: '+1' },
    { code: 'TV', phoneCode: '+688' },
    { code: 'TW', phoneCode: '+886' },
    { code: 'TZ', phoneCode: '+255' },
    { code: 'UA', phoneCode: '+380' },
    { code: 'UG', phoneCode: '+256' },
    { code: 'UM', phoneCode: '+1' },
    { code: 'US', phoneCode: '+1' },
    { code: 'UY', phoneCode: '+598' },
    { code: 'UZ', phoneCode: '+998' },
    { code: 'VA', phoneCode: '+379' },
    { code: 'VC', phoneCode: '+1' },
    { code: 'VE', phoneCode: '+58' },
    { code: 'VG', phoneCode: '+1' },
    { code: 'VI', phoneCode: '+1' },
    { code: 'VN', phoneCode: '+84' },
    { code: 'VU', phoneCode: '+678' },
    { code: 'WF', phoneCode: '+681' },
    { code: 'WS', phoneCode: '+685' },
    { code: 'YE', phoneCode: '+967' },
    { code: 'YT', phoneCode: '+262' },
    { code: 'ZA', phoneCode: '+27' },
    { code: 'ZM', phoneCode: '+260' },
    { code: 'ZW', phoneCode: '+263' },
];

const REGIONS = {
    AU: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
    CA: ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
    MX: [
        'AG',
        'BC',
        'BS',
        'CM',
        'CS',
        'CH',
        'CO',
        'CL',
        'DF',
        'DG',
        'GT',
        'GR',
        'HG',
        'JA',
        'ME',
        'MI',
        'MO',
        'NA',
        'NL',
        'OA',
        'PB',
        'QE',
        'QR',
        'SL',
        'SI',
        'SO',
        'TB',
        'TM',
        'TL',
        'VE',
        'YU',
        'ZA',
    ],
    US: [
        'AL',
        'AK',
        'AZ',
        'AR',
        'CA',
        'CO',
        'CT',
        'DC',
        'DE',
        'FL',
        'GA',
        'HI',
        'ID',
        'IL',
        'IN',
        'IA',
        'KS',
        'KY',
        'LA',
        'ME',
        'MD',
        'MA',
        'MI',
        'MN',
        'MS',
        'MO',
        'MT',
        'NE',
        'NV',
        'NH',
        'NJ',
        'NM',
        'NY',
        'NC',
        'ND',
        'OH',
        'OK',
        'OR',
        'PA',
        'PR',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VT',
        'VA',
        'WA',
        'WV',
        'WI',
        'WY',
    ],
};

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (Array.isArray(token)) {
        return '[' + token.map(stringify).join(', ') + ']';
    }
    if (token == null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return `${token.overriddenName}`;
    }
    if (token.name) {
        return `${token.name}`;
    }
    const res = token.toString();
    if (res == null) {
        return '' + res;
    }
    const newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
function getClosureSafeProperty(objWithPropertyToExtract) {
    for (const key in objWithPropertyToExtract) {
        if (objWithPropertyToExtract[key] === getClosureSafeProperty) {
            return key;
        }
    }
    throw Error('Could not find renamed property on target object.');
}
const __forward_ref__ = getClosureSafeProperty({ __forward_ref__: getClosureSafeProperty });
/**
 * Allows to refer to references which are not yet defined.
 *
 * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
 * DI is declared, but not yet defined. It is also used when the `token` which we use when creating
 * a query is not yet defined.
 *
 * `forwardRef` is also used to break circularities in standalone components imports.
 *
 * @usageNotes
 * ### Circular dependency example
 * {@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref'}
 *
 * ### Circular standalone reference import example
 * ```ts
 * @Component({
 *   imports: [ChildComponent],
 *   template: `<app-child [hideParent]="hideParent"></app-child>`,
 * ...
 * })
 * export class ParentComponent {
 *   @Input() hideParent: boolean;
 * }
 *
 *
 * @Component({
 *   imports: [CommonModule, forwardRef(() => ParentComponent)],
 *    ...
 * })
 * export class ChildComponent {
 *   @Input() hideParent: boolean;
 * }
 * ```
 */
function forwardRef(forwardRefFn) {
    forwardRefFn.__forward_ref__ = forwardRef;
    forwardRefFn.toString = function () {
        return stringify(this());
    };
    return forwardRefFn;
}
/**
 * Lazily retrieves the reference value from a forwardRef.
 *
 * Acts as the identity function when given a non-forward-ref value.
 */
function resolveForwardRef(type) {
    return isForwardRef(type) ? type() : type;
}
/** Checks whether a function is wrapped by a `forwardRef`. */
function isForwardRef(fn) {
    return typeof fn === 'function' && fn.hasOwnProperty(__forward_ref__) && fn.__forward_ref__ === forwardRef;
}

const KeyboardKey = {
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_UP: 'ArrowUp',
    END: 'End',
    ENTER: 'Enter',
    HOME: 'Home',
    SPACE: ' ',
    TAB: 'Tab',
};

const ElementRole = {
    PRESENTATION: 'presentation',
    LISTBOX: 'listbox',
};

const Variant = {
    Flat: 'flat',
    Outline: 'outline',
    Text: 'text',
    Link: 'link',
};
const Palette = {
    Primary: 'primary',
    Secondary: 'secondary',
    Info: 'info',
    Warning: 'warning',
    Danger: 'danger',
    Success: 'success',
};
/**
 * A const enum of screen sizes matching the `screens` property of our tailwind config.
 */
const ScreenSizeValue = {
    sm: 481,
    md: 1024,
    lg: 1201,
    xl: 1584,
};
const ScreenSize = {
    sm: `${ScreenSizeValue.sm}px`,
    md: `${ScreenSizeValue.md}px`,
    lg: `${ScreenSizeValue.lg}px`,
    xl: `${ScreenSizeValue.xl}px`,
};

/**
 * Find out if a value is an array and not an empty one
 * @param value The value to check
 */
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
/**
 * Forces an value to be an array. If it's null or undefined, it returns an empty array.
 * Please note, we need to disable eslint no-explicit-any so that the R can extend T = any so Typescript automatically infers the type if it can.
 * @param value The value to force into an array
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forceArray(value) {
    if (Array.isArray(value)) {
        return value;
    }
    else if (value === null || value === undefined) {
        return [];
    }
    else {
        return [value];
    }
}

/**
 * Turns a value into a boolean
 * @param value The value
 */
function toBoolean(value) {
    switch (value) {
        case 'true':
        case 'yes':
        case '1':
        case 1:
        case true:
            return true;
        default:
            return false;
    }
}

let guidIndex = 0;
/**
 * Returns a general unique identifier. This should NEVER be used in a security setting or for persisting data.
 */
function guid() {
    return `ecom-sl-${guidIndex++}`;
}
/**
 * Check if a value is a non-empty string
 * @param value The string to test
 */
function isNonEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
/**
 * Turns a data URI to a file
 * @param dataUri The data uri
 * @param filename The file name
 */
function dataUriToFile(dataUri, filename) {
    const arr = dataUri.split(',');
    const mimeMatch = arr[0]?.match(/:(.*?);/);
    if (!mimeMatch)
        throw new Error('Invalid data uri format');
    const mime = mimeMatch[1];
    const value = arr[arr.length - 1];
    if (!value)
        throw new Error('Invalid data uri');
    const bstr = atob(value);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

/**
 * Deep freezes an object
 * @param object The object to freeze
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deepFreeze(object) {
    // Retrieve the property names defined on object
    const propNames = Reflect.ownKeys(object);
    // Freeze properties before freezing self
    for (const name of propNames) {
        const value = object[name];
        if ((!Object.isFrozen(value) && value && typeof value === 'object') || typeof value === 'function') {
            deepFreeze(value);
        }
    }
    return Object.freeze(object);
}
/**
 * Return the object keys
 * @param obj The object to get it's keys from
 */
function keys(obj) {
    return Object.keys(obj);
}
/**
 * Recurseviely tries to get a property on deeply nested objects so you dont have to do multiple conditions.
 * @public
 * @function
 * @name getProperty
 * @param {Object} root The object to start getting properties on.
 * @param {String|String[]} path The path can be a period dilimited string or an array of properties in order.
 * @return {*} The property. If it doesn't find it, it will return undefined.
 */
function getProperty(root, path) {
    if (!isObject(root) || (!isNonEmptyString(path) && !isNonEmptyArray(path))) {
        return;
    }
    const parts = Array.isArray(path) ? path : path.split('.');
    // If we only have one key to lookup or is the last property, go ahead and return it.
    const firstPart = parts[0];
    if (parts.length === 1 && firstPart) {
        return root[firstPart];
    }
    const currentKey = parts.shift();
    if (!isNonEmptyString(currentKey)) {
        throw new TypeError('you generated an empty key');
    }
    if (!isObject(root[currentKey]) || !parts.length) {
        return root[currentKey];
    }
    return getProperty(root[currentKey], parts);
}

/**
 * Creates an object for defining locales within the storefront or composable admin.
 *
 * It's expected that you pass in a Record<string, string>, where the value is blank if it matches the target, or the actual target.
 * If the value is blank, we will `.toLowerString()` the key as all sections and targets in storefront/admin must be all lowercase.
 * @param section The section of all the locales.
 * @param locales The targets.
 */
const defineLocaleTargets = (section, locales) => {
    const obj = {};
    keys(locales).forEach((key) => {
        obj[key] = `${section}.${locales[key]?.length ? locales[key] : key.toString().toLowerCase()}`;
    });
    return obj;
};

/**
 * @deprecated Please import from @accesso/cc-std-lib/language
 */
const Languages = [
    'da',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'fr-CA',
    'it',
    'ja',
    'ko',
    'ms',
    'nl',
    'pl',
    'pt',
    'ru',
    'sv',
    'th',
    'tr',
    'zh-Hans',
    'zh-Hant',
];
/**
 * @deprecated Please import from @accesso/cc-std-lib/language
 */
const SupportedLanguage = {
    Danish: 'da',
    German: 'de',
    English: 'en',
    Spanish: 'es',
    Finnish: 'fi',
    French: 'fr',
    FrenchCanadian: 'fr-CA',
    Italian: 'it',
    Japanese: 'ja',
    Korean: 'ko',
    Malay: 'ms',
    Dutch: 'nl',
    Polish: 'pl',
    Portuguese: 'pt',
    Russian: 'ru',
    Swedish: 'sv',
    Thai: 'th',
    Turkish: 'tr',
    ChineseSimplified: 'zh-Hans',
    ChineseTraditional: 'zh-Hant',
};

const WINDOW = new InjectionToken('WINDOW');
function provideWindow() {
    return {
        provide: WINDOW,
        useFactory: windowFactory,
    };
}
function windowFactory() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
        return window;
    }
    return {};
}
/* istanbul ignore file */
function getWindowMock() {
    let mockStorage = {};
    return {
        addEventListener: () => { },
        removeEventListener: () => { },
        atob: () => '',
        btoa: () => '',
        location: {
            href: '',
            hostname: 'localhost',
            replace: () => { },
        },
        scroll: () => { },
        localStorage: {
            getItem: (key) => mockStorage[key],
            setItem: (key, value) => {
                mockStorage[key] = value;
            },
            removeItem: () => { },
            clear: () => {
                mockStorage = {};
            },
        },
    };
}
// Next line needs to use any because we do NOT want to have to write out all the possible properties/functions about the window object...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function provideWindowMock() {
    const windowMock = getWindowMock();
    return {
        window: windowMock,
        provider: {
            provide: WINDOW,
            useValue: windowMock,
        },
    };
}

class WindowEventService {
    window = inject(WINDOW);
    /**
     * Observe the scroll event on the window. This uses a passive event listener so you should never call preventDefault on the event.
     */
    onScroll$ = fromEvent(this.window, 'scroll', { passive: true });
    /**
     * Observe the resize event on the window. This uses a passive event listener so you should never call preventDefault on the event.
     */
    onResize$ = fromEvent(this.window, 'resize', { passive: true });
    /**
     * A signal of the current dimentions
     */
    windowDimensions = signal({ width: this.window.innerWidth ?? 0, height: this.window.innerHeight ?? 0 });
    dimensions = this.windowDimensions.asReadonly();
    isMobileDimension = computed(() => this.windowDimensions().width < 1024);
    constructor() {
        this.onResize$.subscribe(() => this.windowDimensions.set({ width: this.window.innerWidth, height: this.window.innerHeight }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: WindowEventService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: WindowEventService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: WindowEventService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class WindowEventServiceMock {
    onScroll$ = new Subject();
    onResize$ = new Subject();
    dimensions = signal({ width: 0, height: 0 });
    isMobileDimension = signal(false);
}
function provideWindowEventServiceMock() {
    return {
        provide: WindowEventService,
        useClass: WindowEventServiceMock,
    };
}

class LoggerService {
    log;
    warn;
    error;
    enabled = false;
    document = inject(DOCUMENT);
    route = inject(ActivatedRoute);
    constructor() {
        this.setEnabled();
        this.log = this.createLogger('log');
        this.warn = this.createLogger('warn');
        this.error = this.createLogger('error');
    }
    /**
     * Returns the document object
     */
    getDocument() {
        return this.document;
    }
    /**
     * Find out if logging is enabled.
     */
    isEnabled() {
        return this.enabled;
    }
    /**
     * Creates a logger function. Will return noop if not enabled.
     * @param type The type of console function to use.
     * @returns The function to use as a logger
     */
    createLogger(type) {
        return (...args) => {
            if (!this.enabled || !console || !console[type]) {
                return;
            }
            console[type](...args);
        };
    }
    /**
     * Handles setting the `enabled` flag if its local development or the url param _d is set to true.
     */
    setEnabled(forceLogging = false) {
        // If they want to force logging programatically
        if (forceLogging) {
            this.enabled = true;
            return;
        }
        // Always enable logging for local development
        if (['localhost', '127.0.0.1'].includes(this.getDocument().location.hostname)) {
            this.enabled = true;
            // Check the query parameters for `_d`
        }
        else {
            this.route.queryParams
                .pipe(
            // Filter is needed because of this issue: https://github.com/angular/angular/issues/12157
            filter((params) => keys(params).length > 0), take(1))
                .subscribe((params) => {
                this.enabled = params['_d'] === 'true';
            });
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: LoggerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: LoggerService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: LoggerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class LoggerServiceMock {
    log = jest.fn();
    warn = jest.fn();
    error = jest.fn();
    isEnabled = jest.fn();
    setEnable = jest.fn();
}
function provideLoggerServiceMock() {
    return {
        provide: LoggerService,
        useValue: new LoggerServiceMock(),
    };
}

class EventService {
    /**
     * The event stream
     */
    events = new Subject();
    /**
     * A readonly stream of events
     */
    // prettier-ignore
    events$ = this.events.asObservable();
    /**
     * Publish an event to the event stream
     * @param type The event type
     * @param details The details of the event
     */
    publish(event) {
        this.events.next(event);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: EventService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: EventService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: EventService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class EventServiceMock {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    publisher = new Subject();
    events$ = this.publisher.asObservable();
    publish = jest.fn();
}
function provideEventServiceMock() {
    return {
        provide: EventService,
        useClass: EventServiceMock,
    };
}

const EventName = {
    ACCESSO_PAY: 'accessoPay',
    /**
     * Use this event everytime a user visits the cart page.
     */
    VIEW_CART: 'viewCart',
    /**
     * Use this event everytime a user viewes the mini-cart.
     */
    VIEW_MINI_CART: 'viewMiniCart',
    /**
     * Use this event every time a user searches for a specific term.
     */
    SEARCH_TERM: 'searchTerm',
    /**
     * Use this event when the user proceeds to checkout.
     */
    CHECKOUT_BEGIN: 'checkoutBegin',
    /**
     * Use this event when the user adds or edits shipping information.
     */
    CHECKOUT_UPDATE_SHIPPING: 'checkoutUpdateShipping',
    /**
     * Use this event when the user adds or edits payment information.
     */
    CHECKOUT_UPDATE_PAYMENT: 'checkoutUpdatePayment',
    /**
     * Use this event when the user logs in.
     */
    LOGIN: 'login',
    /**
     * Use this event when the user logs out.
     */
    LOGOUT: 'logout',
    /**
     * Use this event when the user completes a purchase.
     */
    PURCHASE_COMPLETE: 'purchaseComplete',
    /**
     * Use this event when an error occurs.
     */
    ERROR: 'error',
    /**
     * Use this event every time a user visits a page.
     */
    PAGE_VIEW: 'pageView',
    /**
     * Use this event if a user adds products to their cart.
     */
    PRODUCT_ADD_TO_CART: 'productAddToCart',
    /**
     * Use this event if a user adds products to their cart.
     */
    PRODUCT_REMOVE_FROM_CART: 'productRemoveFromCart',
    /**
     * Use this event if a user has viewed a product or an ad of something else.
     */
    PRODUCT_IMPRESSION: 'productImpression',
    /**
     * Use this event if a user selects a product from a list.
     */
    PRODUCT_SELECTED: 'productSelected',
    /**
     * Use this event when a user visits a product details page.
     */
    PRODUCT_VIEWED: 'productViewed',
    /**
     * Use this event if a user has viewed a list of products.
     */
    PRODUCT_LIST_VIEWED: 'productListViewed',
    /**
     * Use this event when a user selects a navigable item.
     */
    SELECT_NAVIGATION: 'selectNavigation',
    /**
     * Use this event if a user has selected some content of a certain type.
     */
    SELECT_CONTENT: 'selectContent',
    /**
     * Use this event if an item is selected from a list of items.
     */
    SELECT_ITEM: 'selectItem',
    /**
     * When a sequence begins
     */
    SEQUENCE_BEGIN: 'sequenceBegin',
    /**
     * When a user views a step in a sequence
     */
    SEQUENCE_STEP_VIEWED: 'sequenceStepViewed',
    /**
     * When a user skips a step in a sequence
     */
    SEQUENCE_STEP_SKIPPED: 'sequenceStepSkipped',
    /**
     * When a user complets a sequence
     */
    SEQUENCE_COMPLETED: 'sequenceCompleted',
};

const SequenceType = {
    CHECKOUT: 'checkout',
    PRODUCT: 'product',
};

const ErrorEventType = {
    UNKNOWN: 'unknown',
    API: 'api',
    PAYMENT: 'payment',
    EXCEPTION: 'exception',
    CONFIGURATION: 'configuration',
};

const APPLICATION_ID = new InjectionToken('APPLICATION_ID');

class GtmEventService {
    isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    window = inject(WINDOW);
    /**
     * Fire's a GTM event with the payload provided in the browser
     * @param payload The GTM Payload to push
     */
    fire(payload) {
        if (!this.isBrowser) {
            return;
        }
        this.window.dataLayer?.push(payload);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: GtmEventService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: GtmEventService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: GtmEventService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const GtmEventName = {
    ACCESSO_PAY: 'accesso.accessoPay',
    PAGEVIEW: 'accesso.pageView',
    IMPRESSION: 'accesso.impression',
    SELECT_PRODUCT: 'accesso.selectProduct',
    VIEW_PRODUCT: 'accesso.viewProduct',
    SELECT_CONTENT: 'accesso.selectContent',
    VIEW_LIST: 'accesso.viewList',
    VIEW_CART: 'accesso.viewCart',
    VIEW_MINI_CART: 'accesso.viewMiniCart',
    SEARCH: 'accesso.search',
    ADD_TO_CART: 'accesso.addToCart',
    REMOVE_FROM_CART: 'accesso.removeFromCart',
    BEGIN_CHECKOUT: 'accesso.beginCheckout',
    ADD_PAYMENT_INFO: 'accesso.addPaymentInfo',
    ADD_SHIPPING_INFO: 'accesso.addShippingInfo',
    LOGIN: 'accesso.login',
    SIGNOUT: 'accesso.signout',
    PURCHASE: 'accesso.purchase',
    ERROR: 'accesso.error',
    SEQUENCE_BEGIN: 'accesso.sequenceBegin',
    SEQUENCE_STEP_VIEWED: 'accesso.sequenceStepViewed',
    SEQUENCE_STEP_SKIPPED: 'accesso.sequenceStepSkipped',
    SEQUENCE_COMPLETED: 'accesso.sequenceCompleted',
};

/*
 * Public API Surface of @accesso/cc-std-lib
 */
// GENERAL

/**
 * Generated bundle index. Do not edit.
 */

export { APPLICATION_ID, ApplicationId, COUNTRIES, ElementRole, ErrorEventType, EventName, EventService, EventServiceMock, GtmEventName, GtmEventService, KeyboardKey, Languages, LoggerService, LoggerServiceMock, Palette, REGIONS, ScreenSize, ScreenSizeValue, SequenceType, SupportedLanguage, Variant, WINDOW, WindowEventService, WindowEventServiceMock, dataUriToFile, deepFreeze, defineLocaleTargets, forceArray, forwardRef, getProperty, getWindowMock, guid, isForwardRef, isNonEmptyArray, isNonEmptyString, keys, provideEventServiceMock, provideLoggerServiceMock, provideWindow, provideWindowEventServiceMock, provideWindowMock, resolveForwardRef, toBoolean, windowFactory };
